import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tiersApi, TierCreateRequest, TierUpdateRequest, TierPatchRequest } from '../api';

export const useTierList = () => {
  return useQuery({
    queryKey: ['tiers'],
    queryFn: () => tiersApi.list(),
  });
};

export const useTier = (tierId: string) => {
  return useQuery({
    queryKey: ['tier', tierId],
    queryFn: () => tiersApi.get(tierId),
    enabled: !!tierId,
  });
};

export const useTierSchema = () => {
  return useQuery({
    queryKey: ['tier-schema'],
    queryFn: () => tiersApi.getSchema(),
  });
};

export const useCreateTier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TierCreateRequest) => tiersApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiers'] });
    },
  });
};

export const useUpdateTier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ tierId, data }: { tierId: string; data: TierUpdateRequest }) => tiersApi.update(tierId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiers'] });
    },
  });
};

export const usePatchTier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ tierId, data }: { tierId: string; data: TierPatchRequest }) => tiersApi.patch(tierId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiers'] });
    },
  });
};

export const useDeleteTier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tierId: string) => tiersApi.delete(tierId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tiers'] });
    },
  });
};
